import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import './mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import { initSentry } from './sentry';

// Initialise Bugsink / Sentry error tracking as early as possible so that
// any errors thrown during app boot are captured.
initSentry();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
                <App/>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
